import React, { useEffect,useState } from 'react';
import { Card, Col, Container, Modal, Row } from 'react-bootstrap';
import blog1 from '../assets/1.png';
import blog2 from '../assets/2.png';
import blog3 from '../assets/3.png';
import blog4 from '../assets/4.png';
import blog5 from '../assets/5.png';
import blog6 from '../assets/6.png';
import blog7 from '../assets/7.png';
import blog8 from '../assets/8.png';
import blog9 from '../assets/9.png';
import blog10 from '../assets/10.png';
import blog11 from '../assets/11.png';
import blog12 from '../assets/12.png';
import blog13 from '../assets/13.png';
import blog14 from '../assets/14.png';
import blog15 from '../assets/15.png';
import blog16 from '../assets/16.png';
import blog17 from '../assets/17.png';
import blog18 from '../assets/18.png';
import blog19 from '../assets/19.png';
  import blog20 from '../assets/20.png';
import blog21 from '../assets/21.png';


import ProjectCard from './Projects/ProjectCard';
const Work = () => {
  const projectsData = [
    { image: blog17, link: 'https://chatgenie-web.netlify.app/' },
    { image: blog18, link: 'https://finance-expense-tracker.netlify.app/' },
    { image: blog19, link: 'https://aicodereviewer-web.netlify.app/' },
       { image: blog20, link: 'https://drive.google.com/drive/folders/1jaJdhIMzM4gyky8Z5laLFmNF1m6ZseQ0' },
      { image: blog21, link: 'https://edutrack-platform.netlify.app/' },
    
    { image:blog1, link: 'https://vehicle-web.netlify.app/' },
    { image: blog2, link: 'https://sports-web.netlify.app/' },
    { image: blog3, link: 'https://dsp-web.netlify.app/' },
    { image:blog4, link: 'https://soormiyun.netlify.app/' },
    { image: blog5, link: 'https://mehfooz-mustaqbil-foundation.web.app/' },
    { image: blog6, link: 'https://lordhosting.netlify.app/' },
    { image:blog7, link: 'https://digitalize-web.netlify.app/' },
    { image: blog8, link: 'https://covidchartt.netlify.app/' },
    // { image: blog9, link: 'https://dps-web.netlify.app/about' },
    { image: blog10, link: 'https://dps-web.netlify.app' },
    { image: blog11, link: 'https://sajahabidi-web.netlify.app/' },
    { image: blog12, link: 'https://smg-web.netlify.app/' },
    { image: blog13, link: 'http://www.g3dprints.de/' },
    
    { image: blog14, link: 'https://mohaghegh-web.netlify.app/' },
    
    { image: blog15, link: 'https://securegroup.netlify.app/' },
    { image: blog16, link: 'https://www.linkedin.com/feed/update/urn:li:activity:7249522217686843392/' },


    
    
  ];
  return (
    <section className="portfolio_con" id="portfolio">
  
    <Row className="blog-row" style={{margin:"4rem 0"}}> {/* Adding custom class to Row */}
        {projectsData.map((project, index) => (
        <ProjectCard key={index} image={project.image} link={project.link} />
      ))}
      </Row>
</section>
  )
}

export default Work
